import type { Variants } from 'framer-motion'

export const colors = {
  lime: '#ccff00',
  cyan: '#00ffff',
  pink: '#ff006e',
  bg: '#0a0a0a',
  cardBg: 'rgba(255, 255, 255, 0.05)',
  border: 'rgba(255, 255, 255, 0.1)',
} as const

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: 'easeOut' } },
}

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.3 } },
}

export const scaleOnHover = {
  whileHover: { scale: 1.02 },
  whileTap: { scale: 0.98 },
  transition: { type: 'spring' as const, stiffness: 400, damping: 25 },
}

export const stagger = {
  visible: {
    transition: {
      staggerChildren: 0.05,
    },
  },
}

export const sidebarSpring = {
  type: 'spring' as const,
  stiffness: 300,
  damping: 30,
}
